import { render, staticRenderFns } from "./ComplaintFollowUpTable.vue?vue&type=template&id=08396125&"
import script from "./ComplaintFollowUpTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports